import DeleteMatrixHeaderDialog from "./delete-matrix-header-dialog.jsx";

export default DeleteMatrixHeaderDialog;
